var render, staticRenderFns
import script from "./Footer.vue?vue&type=script&lang=tsx&"
export * from "./Footer.vue?vue&type=script&lang=tsx&"
import style0 from "./Footer.vue?vue&type=style&index=0&id=25117886&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25117886",
  null
  
)

export default component.exports